import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase, RequestStatus } from '@lib/plugin-redux-core';
import { GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE, CREATE_CONVERSATION_USE_CASE } from '../../../ai/src';
import { selectCurrentConversationId, selectMessages, selectGetConversationsWithMessagesStatus, selectError } from '../redux/ai-chat/ai-chat.selectors';
var SKILL_ID = 'bff017f5-f2e6-4029-ade7-2450fb2ff658';
export var useConversationMessages = function useConversationMessages(_ref) {
  var resourceId = _ref.resourceId,
      _ref$resourceType = _ref.resourceType,
      resourceType = _ref$resourceType === void 0 ? 'form' : _ref$resourceType;
  var dispatch = useDispatch();
  var currentConversationId = useSelector(selectCurrentConversationId);
  var messages = useSelector(selectMessages);
  var getConversationsWithMessagesStatus = useSelector(selectGetConversationsWithMessagesStatus);
  var getConversationsWithMessagesUseCase = getUseCase(GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE, dispatch);
  var createConversationUseCase = getUseCase(CREATE_CONVERSATION_USE_CASE, dispatch);
  useEffect(function () {
    getConversationsWithMessagesUseCase.execute({
      resourceId: resourceId,
      resourceType: resourceType
    }); // eslint-disable-next-line react-hooks/exhaustive-deps -- only refetch when resource changes; use case reference is unstable
  }, [resourceId, resourceType]);
  var createNewConversation = useCallback(function () {
    createConversationUseCase.execute({
      title: 'Untitled',
      skillId: SKILL_ID,
      resourceId: resourceId,
      resourceType: resourceType,
      context: '',
      tags: []
    });
  }, [createConversationUseCase, resourceId, resourceType]);
  var error = useSelector(selectError);
  return {
    currentConversationId: currentConversationId,
    messages: messages !== null && messages !== void 0 ? messages : [],
    isLoadingGetConversationsWithMessages: getConversationsWithMessagesStatus === RequestStatus.EXECUTE,
    error: error,
    createNewConversation: createNewConversation
  };
};